import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  IonicPage,
  NavController,
  Slides,
  ViewController,
  ActionSheetController,
  ToastController,
  Platform,
  LoadingController
} from "ionic-angular";
import { CategoriesProvider } from "../../providers/categories/categories.provider";
import { TranslateService } from "@ngx-translate/core";
import { EventsProvider } from "../../providers/events/events.provider";
import { GeocodingProvider } from "../../providers/geocoding/geocoding.provider";
import { UserProvider } from "../../providers/user/user.provider";
import { ChatProvider } from "../../providers/chat/chat.provider";
import { Camera } from "@ionic-native/camera";
import { MockupProvider } from "../../providers/mockup/mockup.provider";
import { Geolocation } from "@ionic-native/geolocation";

declare const google;
/**
 * Generated class for the EventCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-event-create",
  templateUrl: "event-create.html"
})
export class EventCreatePage {
  categories: any = [];
  icon: any = null;
  @ViewChild(Slides) slides: Slides;
  map: any;
  @ViewChild("map") mapElement: ElementRef;

  @ViewChild("file") fileInput: ElementRef;
  fileToUpload: File = null;
  picture: any = null;
  loading: any = null;
  address_selected: any = null;
  canvas: any = {
    width: 1000,
    height: 1000
  };
  size: any = {
    width: 1000,
    height: 1000
  };
  preview: any = null;
  currentIndex: any = 0;
  canvas_ctx: any;
  i18n: string[] = [];
  search_address = "";
  address_list: any;
  place: any;
  edited: boolean = false;
  event: any = {
    title:'',
    description:'',
    date:new Date().toISOString(),
    picture: "",
    created_by: null,
    created_at: new Date().toISOString()
  };

  step: any = 1;
  searched = false;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    private translate: TranslateService,
    private loadingCtrl: LoadingController,
    private camera: Camera,
    private platform: Platform,
    private mockupProvider: MockupProvider,
    private eventsProvider: EventsProvider,
    private geocodingProvider: GeocodingProvider,
    public geolocation: Geolocation,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private userProvider: UserProvider
  ) {
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad EventCreatePage");
    this.slides.lockSwipeToNext(true);
    // this.address_list = this.address_list_default;
    console.log("this.address_list", this.address_list);
    this.refresh();
  }

  async refresh() {
    this.refreshLang();
    this.slideChanged();
    this.takeDemoPicture();
    this.initAutocomplete();
    // this.onCategorieChange();
  }

  onCategorieChange() {
    console.log("onCategorieChange this.categories", this.categories);
    // let category_index = this.categories.findIndex(category => {
    //   return this.event.category == category.id;
    // });
    // console.log("onCategorieChange category_index", category_index);
    // let random_picture = this.categories[category_index].pictures[
    //   Math.floor(
    //     Math.random() * this.categories[category_index].pictures.length
    //   )
    // ];

    // console.log("onCategorieChange random_picture", random_picture);
    // this.event.picture =
    //   "themes/" + this.categories[category_index].theme + "/" + random_picture;
  }

  async onSearchAddress() {
    console.log("onSearchAddress");
    if (this.search_address.length >= 3) {
      this.event.address.place_id = null;
      this.searched = true;
      let address_list = await this.geocodingProvider.searchAddress(
        this.search_address
      );
      this.processResults(address_list);
    }
  }

  processResults(items) {
    let results = [];
    for (let item of items) {
      let title = this.titleResult(item);
      let data = {
        place_id: item.place_id,
        display_name: item.display_name,
        lat: item.lat,
        lon: item.lon,
        title: title,
        city: item.address.city,
        county: item.address.county,
        state: item.address.state,
        country: item.address.country,
      };
      results.push(data);
    }
    this.address_list = results;
  }

  titleResult(result) {
    let title_results = '';
    let items = [
      "cafe",
      "pub",
      "bar",
      "restaurant",
      "building"
    ];
    for (let item of items) {
      if (result["address"][item]) {
        title_results = result["address"][item];
        return title_results;
      }
    }
  }

  slideChanged() {
    this.currentIndex = this.slides.getActiveIndex();
    console.log("Current index is", this.currentIndex);
  }

  cancel() {
    this.viewCtrl.dismiss(null);
  }

  rangeChange() {
    console.log("rangeChange", this.event.users_max);
    // if(this.event.users_max < 49){
    //   this.step = 1;
    // }
    // if(this.event.users_max == 50){
    //   this.event.users_max = 55;
    //   this.step = 5;
    // }
    // if(this.event.users_max == 99){
    //   this.step = 10;
    // }
  }

  refreshLang() {
    // console.log("refresh lang");
    this.translate
      .get([
        "PICTURE_ADDED_TO_GALLERY",
        "PICTURE_DOWNLOADED",
        "ERROR_SAVING_GALLERY",
        "EXPORT_IN_PROGRESS",
        "TITLE_ALERT_LEAVE",
        "MESSAGE_ALERT_LEAVE",
        "SAVE",
        "LEAVE_WITHOUT_SAVE",
        "SELECT_PICTURE",
        "OK",
        "YES",
        "NO",
        "CANCEL",
        "TITLE",
        "SUBTITLE",
        "DEMO_PICTURE",
        "LOAD_FROM_LIBRARY",
        "LOAD_FROM_COMPUTER",
        "USE_CAMERA"
      ])
      .subscribe(value => {
        this.i18n = value;
        // console.log("this.i18n",this.i18n);
      });
  }

  slideNext() {
    this.slides.lockSwipeToNext(false);
    this.slides.slideNext();
    this.slides.lockSwipeToNext(true);
  }


  async createEvent() {
    let user = await this.userProvider.getUser();
    let event = this.event;

    if(this.place){
      this.event.place = {
        formatted_address: this.place.formatted_address,
        location: {lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()}
      };
      console.log("this.event.place",this.event.place);
    }
    // console.log("address_index", address_index);
    // console.log("address_list", this.address_list);
    // event.address = {
    //   place_id: event.address.place_id,
    //   title: this.address_list[address_index].title,
    //   display_name: this.address_list[address_index].display_name,
    //   lat:  this.address_list[address_index].lat,
    //   lon:  this.address_list[address_index].lon,
    //   city:  this.address_list[address_index].city,
    //   county:  this.address_list[address_index].county,
    //   state:  this.address_list[address_index].state,
    //   country:  this.address_list[address_index].country,
    // };

    // event.created_by = user.uid;
    // event.users = [user.uid];
    console.log("createEvent", event);
    let event_created = await this.eventsProvider.createEvent(event);
    console.log("event_created", event_created);
    console.log("event_created id", event_created.id);
    // let event_id = "9yngO3rHvEUkG6JmGkOw";
    // let event_chat: any = {
    //   event_id:event_created.id,
    //   messages: [],
    //   created_by: user.uid,
    //   created_at: new Date().toISOString()
    // };
    // let chat_result = await this.chatProvider.createChat(event_);
    // let chat_result = 'test';
    this.viewCtrl.dismiss();
  }



  presentActionSheet() {
    let button_library = {
      text: this.i18n["LOAD_FROM_LIBRARY"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    };
    let button_camera = {
      text: this.i18n["USE_CAMERA"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.CAMERA);
      }
    };
    let button_import_web = {
      text: this.i18n["LOAD_FROM_COMPUTER"],
      handler: () => {
        this.triggerFileInputClick();
      }
    };
    let button_cancel = {
      text: this.i18n["CANCEL"],
      role: "cancel"
    };
    let button_demo = {
      text: this.i18n["DEMO_PICTURE"],
      handler: () => {
        this.takeDemoPicture();
      }
    };
    let buttons = [button_demo, button_import_web, button_cancel];
    if (this.platform.is("cordova"))
      buttons = [button_demo, button_library, button_camera, button_cancel];

    let titletext = this.i18n["SELECT_PICTURE"];
    // console.log("titletext",titletext);
    let actionSheet = this.actionSheetCtrl.create({
      title: titletext,
      buttons: buttons
    });
    actionSheet.present();
  }

  triggerFileInputClick() {
    this.fileInput.nativeElement.click();
  }

  takeDemoPicture() {
    this.mockupProvider
      .getImageDemo()
      .then(dataUrl => {
        // console.log("takeDemoPicture success");
        return this.getPicture(dataUrl);
      })
      .then(picture => {
        this.edited = true;
      })
      .catch(err => {
        console.error("error loading takeDemoPicture", err);
      });
  }

  async takePicture(sourceType) {
    var options = {
      quality: 100,
      sourceType: sourceType,
      targetWidth: 1024,
      targetHeight: 1024,
      destinationType: this.camera.DestinationType.DATA_URL,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };

    this.camera.getPicture(options).then(
      dataUrl => {
        // console.log("takePicture",dataUrl);
        this.getPicture(dataUrl)
          .then(picture => {
            // console.log("picture", picture);
            this.edited = true;
          })
          .catch(err => {
            console.error("error loading takeDemoPicture", err);
          });
      },
      err => {
        this.presentToast("Error while selecting image.");
      }
    );
  }

  onFileInputChange(files: FileList) {
    this.fileToUpload = files.item(0);

    if (this.fileInput.nativeElement.value != "") {
      // console.log('onFileInputChange', this.fileInput.nativeElement.value);
      // console.log('this.fileToUpload', this.fileToUpload);
      this.fileToBase64(this.fileToUpload);
      // this.upload();
    }
  }
  fileToBase64(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // console.log(reader.result);
      let data = reader.result.toString();
      data = data.replace("data:image/png;base64,", "");
      data = data.replace("data:image/jpeg;base64,", "");
      data = data.replace("data:image/jpg;base64,", "");
      data = data.replace("data:image/webp;base64,", "");
      data = data.replace("data:image/gif;base64,", "");
      // console.log("file",file);
      // console.log("reader",reader);
      this.edited = true;
      this.getPicture(data);
    };
    reader.onerror = error => {
      console.log("Error: ", error);
    };
  }

  async getPicture(dataUrl) {
    let picture_name = new Date().getTime();
    let picture = {
      title: picture_name,
      contenu: "data:image/png;base64," + dataUrl
    };
    // console.log("getPicture",picture);
    this.event.picture = picture.contenu;
  }

  presentLoading(content = "Please wait...") {
    this.loading = this.loadingCtrl.create({
      content: content
    });

    this.loading.present();
  }

  hideLoading() {
    this.loading.dismiss();
  }

  presentToast(message, duration = 3000) {
    // console.log('presentToast', message)
    let toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: "middle",
      cssClass: "custom_toast"
    });

    toast.onDidDismiss(() => {
      console.log("Dismissed toast");
    });

    toast.present();
  }

  getPosition() {
    var iconBase = "http://icons.iconarchive.com/icons/icons-land/vista-map-markers/32/Map-Marker-Ball-Chartreuse-icon.png";
    
    console.log("getPosition");
    this.geolocation
      .getCurrentPosition()
      .then(resp => {

        this.map.setZoom(15);
        this.map.panTo({lat: resp.coords.latitude, lng:resp.coords.longitude});

        new google.maps.Marker({
          map: this.map,
          position: {lat: resp.coords.latitude, lng:resp.coords.longitude},
          visible: true,
          icon: iconBase,
        });
      })
      .catch(error => {
        console.log("Error getting location", error);
    });
  }

  initAutocomplete() {
    var iconBase = "http://icons.iconarchive.com/icons/icons-land/vista-map-markers/32/Map-Marker-Ball-Chartreuse-icon.png";
    
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      center: {lat:48.128868399999995,lng:-1.6626363},
      zoom: 16,
      disableDefaultUI: true,
    });
    // var content = '<div class="time"><p>5</p><p>min</p></div><p>Set Pickup Location</p><a href="#"><span class="go">></span></a>';
    // var infoWindow = new google.maps.InfoWindow({
    //   map: map,
    //   content: content
    // });

    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        var marker = new google.maps.Marker({
          map: this.map,
          position: pos,
          visible: true,
          icon: iconBase,
        });
        // google.maps.event.addListener(infoWindow, 'domready', function () {
        //   $('.gm-style-iw').parent().addClass('custom-iw');
        //   $('.custom-iw').children(':nth-child(3)').css({
        //     'display': 'none',
        //   });
        // });
        // infoWindow.setPosition(pos);
        // infoWindow.setContent(content);
        this.map.setCenter(pos);
      }, (err) => {
        console.error("getCurrentPosition err", err);
        // handleLocationError(true, infoWindow, map.getCenter());
      });
    } else {
      // Browser doesn't support Geolocation

      // handleLocationError(false, infoWindow, map.getCenter());
    }

    function handleLocationError(browserHasGeolocation, infoWindow, pos) {
      infoWindow.setPosition(pos);
      infoWindow.setContent(browserHasGeolocation ?
        'Error: The Geolocation service failed.' :
        'Error: Your browser doesn\'t support geolocation.');
    };

    //Search box
    var input = document.getElementById('pac-input');
    var searchBox = new google.maps.places.SearchBox(input);
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    // Bias the SearchBox results towards current map's viewport.
    setTimeout(() => {
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds());
      });
    },500);
    var markers = [];
    this.place = null;
    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    searchBox.addListener('places_changed', () => {
      var places = searchBox.getPlaces();

      if (places.length == 0) {
        return;
      }

      // Clear out the old markers.
      markers.forEach((marker)  => {
        marker.setMap(null);
      });
      var iconBase = "http://icons.iconarchive.com/icons/icons-land/vista-map-markers/32/Map-Marker-Ball-Chartreuse-icon.png";
    
      markers = [];
      // For each place, get the icon, name and location.
      var bounds = new google.maps.LatLngBounds();
      places.forEach((place) => {
        if (!place.geometry) {
          console.log("Returned place contains no geometry");
          return;
        }

        // Create a marker for each place.
        markers.push(new google.maps.Marker({
          map: this.map,
          icon: iconBase,
          title: place.name,
          position: place.geometry.location
        }));

        this.place = place;

        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      this.map.fitBounds(bounds);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/event-create/event-create.ts